// extracted by mini-css-extract-plugin
export default {"root":"HmLYZUyR","title":"_0HumMmdM","subtitle":"zsGbF4Bk"};